import { getApiErrorCode } from '@percent/admin-dashboard/common/library/getApiErrorCode'

const SERVICE_ERROR_KEYS = {
  'services/name_taken': 'internalServices.error.nameTaken',
  'services/role_already_held': 'internalServices.error.roleAlreadyHeld',
  'services/last_owner': 'internalServices.error.lastOwner',
  'services/role_not_found': 'internalServices.error.roleNotFound',
  'services/holder_not_found': 'internalServices.error.holderNotFound'
} as const

type ServiceErrorCode = keyof typeof SERVICE_ERROR_KEYS

const isServiceErrorCode = (code: string | undefined): code is ServiceErrorCode =>
  code !== undefined && Object.prototype.hasOwnProperty.call(SERVICE_ERROR_KEYS, code)

/** The copy for a refusal the services API explains with its own error code, if it is one. */
export const getServiceErrorKey = (error: unknown) => {
  const code = getApiErrorCode(error)

  return isServiceErrorCode(code) ? SERVICE_ERROR_KEYS[code] : undefined
}

export const isNameTaken = (error: unknown) => getApiErrorCode(error) === 'services/name_taken'
